export class GenHolidaysEntity {
    
    id: number;
    holidays: string;
    active: boolean;
    userId: number;
    constructor (){}
}